import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=70efa439&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"
import style0 from "./Evaluate.vue?vue&type=style&index=0&id=70efa439&prod&lang=less&scoped=true"
import style1 from "./Evaluate.vue?vue&type=style&index=1&id=70efa439&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70efa439",
  null
  
)

export default component.exports